<header [class.fixed]="isFixed" [class.home-theme]="isHome">
  <div class="container-full">
    <div class="header-wrapper">
      <div class="d-flex align-items-center">
        <div class="logo">
          <a routerLink="/">
            @if(isHome) {
            <img src="./assets/images/logo-colored.svg" alt="">
            } @else {
            <img src="./assets/images/logo.svg" alt="">
            }
          </a>
        </div>
        <button class="nav-btn mobile" [class.open]="menuOpened" (click)="menuOpened = !menuOpened">
          <i></i><i></i><i></i>
        </button>
      </div>
      <ul class="nav" [class.active]="menuOpened" (click)="menuOpened = false">
        <li>
          <a routerLink="/" routerLinkActive="active">
            {{ 'header.Home' | translate }}
          </a>
        </li>
        <li>
          <a routerLink="/categories" routerLinkActive="active">
            {{ 'header.Categories' | translate }}
          </a>
        </li>
        <li>
          <a routerLink="/about" routerLinkActive="active">
            {{ 'header.Who we are' | translate }}
          </a>
        </li>
        <li>
          <a routerLink="/contact" routerLinkActive="active">
            {{ 'header.Contact Us' | translate }}
          </a>
        </li>
      </ul>

      <div class="btns">
        <a href="{{env.appUrl}}/register?lang={{lang}}" class="btn btn-primary">
          {{ 'header.Register Now' | translate }}
        </a>
        <a href="{{env.appUrl}}/login?lang={{lang}}" class="btn"
          [ngClass]="{'btn-outline-primary': isHome, 'btn-outline-light': !isHome}">
          {{ 'header.Login' | translate }}
        </a>
        <button (click)="changeLanguage()" class="btn lang"
          [ngClass]="{'btn-outline-primary': isHome, 'btn-outline-light': !isHome}">
          {{ 'general.language' | translate }}
        </button>
      </div>
    </div>
  </div>
</header>
